<template>
  <v-dialog
      v-model="dialogVisible"
      :width="dialogWidth"
      persistent
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">{{ this.title }}</span>
        <v-spacer/>
        <slot name="title-actions"></slot>
      </v-card-title>

      <v-card-text>
        <slot name="body"></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <slot name="actions"></slot>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import VueTypes from "vue-types";

export default {
  name: "resizable-common-dialog",
  props: {
    title: {
      type: VueTypes.String,
      default: "Dialog"
    },
    dialogVisible: {
      type: VueTypes.Boolean,
      default: false
    },
    startDialogWidth: {
      type: VueTypes.Number,
      default: 800
    },
    startDialogHeight: {
      type: VueTypes.Number,
      default: 420
    },
    startViewPortPadding: {
      type: VueTypes.Number,
      default: 32
    }
  },
  data: () => ({
    visible: false,
    rules: ViewRules.READONLY,

    dialogWidth: 920,
    dialogHeight: 546,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 920,
    resizeStartHeight: 546,
    viewportPadding: 32,
  }),
  mounted() {
    this.dialogWidth = this.startDialogWidth;
    this.dialogHeight = this.startDialogHeight;
    this.resizeStartWidth = this.startDialogWidth;
    this.resizeStartHeight = this.startDialogHeight;
    this.viewportPadding = this.startViewPortPadding;
  },
  methods: {
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;

      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;

      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;

      let newWidth = Number(this.resizeStartWidth) + Number(dx);
      let newHeight = Number(this.resizeStartHeight) + Number(dy);

      const minWidth = 300;
      const minHeight = 300;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;

      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    },
  },
}

</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}

.resizable-card__body {
  flex: 1;
  overflow: auto;
}

.resizable-card__actions {
  flex-shrink: 0;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
</style>